import React from 'react';

const InicioSesion = () => {
  return (
    <div>
      <h1>Inicio Sesion</h1>
    </div>
  );
};

export default InicioSesion;